
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.01 11.014A2.006 2.006 0 009.014 9.01 2.006 2.006 0 007.01 7.006 2.006 2.006 0 005.006 9.01c0 1.105.899 2.004 2.004 2.004z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M19.534 4H4.504A2.508 2.508 0 002 6.505v11.021a2.508 2.508 0 002.505 2.505h15.03a2.508 2.508 0 002.504-2.505V6.505A2.509 2.509 0 0019.534 4zM4.504 6.004h15.03c.277 0 .501.224.501.501v7.113L16.87 9.925a1.795 1.795 0 00-1.344-.616 1.751 1.751 0 00-1.338.632l-3.722 4.466-1.212-1.209a1.759 1.759 0 00-2.485 0l-2.765 2.764V6.505c0-.277.224-.501.5-.501z","fill":"#282E3E"}})])
          )
        }
      }
    